module.exports = __webpack_public_path__ + "img/1.a0c5558d.png";